import Nullstack from 'nullstack';
export default function IconPlugX({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-plug-x",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M13.55 17.733a5.806 5.806 0 0 1 -7.356 -4.052a5.81 5.81 0 0 1 1.537 -5.627l2.054 -2.054l7.165 7.165"
  }), "   ", Nullstack.element("path", {
    d: "M4 20l3.5 -3.5"
  }), "   ", Nullstack.element("path", {
    d: "M15 4l-3.5 3.5"
  }), "   ", Nullstack.element("path", {
    d: "M20 9l-3.5 3.5"
  }), "   ", Nullstack.element("path", {
    d: "M16 16l4 4"
  }), "   ", Nullstack.element("path", {
    d: "M20 16l-4 4"
  }), " ");
}